import React, { Component } from 'react';
import { AffiliationTemplate } from './../../Templates/index';
import {
  AffiliationAccueilOrganism,
  AffiliationGardePageOrganism,
  AffiliationStage1Organism,
  AffiliationStage2Organism,
  AffiliationStage3Organism,
  AffiliationStage4Organism,
  AffiliationStage5Organism
} from './../../Organisms/index';

const initialState = {
  stage: -1,
  data: {
    firstName: '',
    lastName: '',
    date: null,
    familySituation: '',
    securityNumber: '',
    rattachement: '',
    mail: '',
    phoneNumber: '',
    adress: '',
    postalAdress: '',
  },
  remboursementData: [
    {
      name: '',
      IBAN: '',
      BIC: '',
    }
  ],
  prelevmentData: [
    {
      name: '',
      IBAN: '',
      BIC: '',
    }
  ],
  ayantDroitData: {
    check: '',
    beneficiaryType: '',
    firstName: '',
    lastName: '',
    date: null,
    securityNumber: '',
    rattachement: '',
    laserRank: '',
    childNAC: false,
  },
  check: '',
  option: '',
  dispense: false,
  checkBoxAyantDroitRemboursement: '',
  DispenseOnecheck: '',
};
class Affiliation extends Component {
  constructor(props) {
    super(props);
    this.state = initialState
  }

  beginAffiliationClicked = () => {
    this.setState({
      stage: 0
    })
  }

  inputChange = (value, key) => {
    if (key == 'date') {
      value = new Date(value)
    }
    this.setState({
      data: { ...this.state.data, [key]: value }
    })
  }

  checkBoxClicked = (value) => {
    this.setState({
      check: value
    })
  }

  confirmerClicked = () => {
    if (this.state.stage == 5) {
      this.setState(initialState)
      this.props.history.push('/')
    }
    this.setState({
      stage: this.state.stage + 1
    })
  }

  goBackClicked = () => {
    this.setState({
      stage: this.state.stage - 1
    })
  }

  optionClicked = (value) => {
    this.setState({
      option: value
    })
  }

  dispenseClicked = () => {
    this.setState({
      dispense: true
    })
  }

  inputRemboursementChange = (value, object) => {
    const aux = this.state.remboursementData
    aux[object.index] = { ...aux[object.index], [object.value]: value }
    this.setState({
      remboursementData: aux
    })
  }

  addRemboursement = () => {
    const aux = this.state.remboursementData
    aux.push({
      name: '',
      IBAN: '',
      BIC: '',
    })
    this.setState({
      remboursementData: aux
    })
  }

  inputPrelevmentChange = (value, object) => {
    const aux = this.state.prelevmentData
    aux[object.index] = { ...aux[object.index], [object.value]: value }
    this.setState({
      prelevmentData: aux
    })
  }

  addPrelevment = () => {
    const aux = this.state.prelevmentData
    aux.push({
      name: '',
      IBAN: '',
      BIC: '',
    })
    this.setState({
      prelevmentData: aux
    })
  }

  checkBoxAyantDroitClicked = (value) => {
    this.setState({
      ayantDroitData: { ...this.state.ayantDroitData, check: value }
    })
  }

  inputAyantDroitChange = (value, key) => {
    if (key == 'date') {
      value = new Date(value)
    }
    this.setState({
      ayantDroitData: { ...this.state.ayantDroitData, [key]: value }
    })
  }

  showLazerNAC = () => {
    return (this.state.ayantDroitData.check &&
      this.state.ayantDroitData.beneficiaryType &&
      this.state.ayantDroitData.firstName &&
      this.state.ayantDroitData.lastName &&
      this.state.ayantDroitData.date &&
      this.state.ayantDroitData.securityNumber &&
      this.state.ayantDroitData.rattachement)
  }

  checkBoxAyantDroitRemboursementClicked = (value) => {
    this.setState({
      checkBoxAyantDroitRemboursement: value
    })
  }

  dispenseConfirmClicked = () => {
    this.props.history.push('/dispense')
  }

  dispenseCancelClicked = () => {
    this.setState({
      dispense: false
    })
  }

  AffiliationConfirmClicked = () => {
    this.setState({
      stage: 1
    })
  }

  AffiliationCancelClicked = () => {
    this.setState({
      stage: -1
    })
  }

  renderSwitch(param) {
    switch (param) {
      case -1:
        return <AffiliationGardePageOrganism
          beginAffiliationClicked={this.beginAffiliationClicked}
          dispenseClicked={this.dispenseClicked}
        />
      case 0:
        return <AffiliationAccueilOrganism
          AffiliationConfirmClicked={this.AffiliationConfirmClicked}
          AffiliationCancelClicked={this.AffiliationCancelClicked}
        />
      case 1:
        return <AffiliationStage1Organism
          stage={this.state.stage}
          inputChange={this.inputChange}
          data={this.state.data}
          checkBoxClicked={this.checkBoxClicked}
          check={this.state.check}
          confirmerClicked={this.confirmerClicked}
          goBackClicked={this.goBackClicked}
        />
      case 2:
        return <AffiliationStage2Organism
          stage={this.state.stage}
          checkBoxClicked={this.checkBoxClicked}
          confirmerClicked={this.confirmerClicked}
          goBackClicked={this.goBackClicked}
          optionClicked={this.optionClicked}
          option={this.state.option}
        />
      case 3:
        return <AffiliationStage3Organism
          stage={this.state.stage}
          confirmerClicked={this.confirmerClicked}
          goBackClicked={this.goBackClicked}
          option={this.state.option}
          inputRemboursementChange={this.inputRemboursementChange}
          remboursementData={this.state.remboursementData}
          addRemboursement={this.addRemboursement}
          prelevmentData={this.state.prelevmentData}
          inputPrelevmentChange={this.inputPrelevmentChange}
          addPrelevment={this.addPrelevment}
        />
      case 4:
        return <AffiliationStage4Organism
          stage={this.state.stage}
          confirmerClicked={this.confirmerClicked}
          goBackClicked={this.goBackClicked}
          ayantDroitData={this.state.ayantDroitData}
          checkBoxAyantDroitClicked={this.checkBoxAyantDroitClicked}
          inputAyantDroitChange={this.inputAyantDroitChange}
          showLazerNAC={this.showLazerNAC}
          checkBoxAyantDroitRemboursement={this.state.checkBoxAyantDroitRemboursement}
          checkBoxAyantDroitRemboursementClicked={this.checkBoxAyantDroitRemboursementClicked}
        />
      case 5:
        return <AffiliationStage5Organism
          stage={this.state.stage}
          confirmerClicked={this.confirmerClicked}
          goBackClicked={this.goBackClicked}
        />
      default:
        return null
    }
  }

  dispenseOneCheckClicked = (value) => {
    this.setState({
      DispenseOnecheck: value
    })
  }

  render() {
    return <AffiliationTemplate
      renderSwitch={this.renderSwitch(this.state.stage)}
      dispense={this.state.dispense}
      dispenseConfirmClicked={this.dispenseConfirmClicked}
      dispenseCancelClicked={this.dispenseCancelClicked}
      dispenseOneCheckClicked={this.dispenseOneCheckClicked}
      DispenseOnecheck={this.state.DispenseOnecheck}
    />
  }
}
export default Affiliation;
